import { createFileRoute } from '@tanstack/react-router'

import { ExpenseImportDetailPage } from '@/pages/expenses/import/[id]/ExpenseImportDetailPage'

export const Route = createFileRoute('/_authenticated/_dashboard/expenses/import/$id/')({
  component: ExpenseImportDetailPage,
})
